var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_133_17",
    "data-name": "Component 133 \\u2013 17",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24329",
    "data-name": "Path 24329",
    d: "M19,0A19,19,0,1,1,0,19,19,19,0,0,1,19,0Z",
    fill: "none",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44615",
    "data-name": "Group 44615",
    transform: "translate(8.25 8.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45152",
    "data-name": "Group 45152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89236",
    "data-name": "Path 89236",
    d: "M20.75,10.75v6.364a3.636,3.636,0,0,1-3.636,3.636H4.386A3.636,3.636,0,0,1,.75,17.114V5.3A3.636,3.636,0,0,1,4.386,1.659H7.114",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89237",
    "data-name": "Path 89237",
    d: "M10.24,14.866,5.7,14.9V10.415L14.336,1.7a3.207,3.207,0,1,1,4.545,4.526Z",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.65f9a07147b8972a273ae29de1516301.svg";
export { ForwardRef as ReactComponent };